/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetCompositionsDetailSocialUploadsQueryResponse, WebAppGetCompositionsDetailSocialUploadsPathParams, WebAppGetCompositionsDetailSocialUploads401, WebAppGetCompositionsDetailSocialUploads403 } from "../models/WebAppGetCompositionsDetailSocialUploads";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetCompositionsDetailSocialUploads } from "../axios/webAppGetCompositionsDetailSocialUploads";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetCompositionsDetailSocialUploadsQueryKey = (id: WebAppGetCompositionsDetailSocialUploadsPathParams["id"]) => ["api-v2", { url: '/web-app/v1/compositions/:id/social-uploads', params: {id:id} }] as const

export type WebAppGetCompositionsDetailSocialUploadsQueryKey = ReturnType<typeof webAppGetCompositionsDetailSocialUploadsQueryKey>

export function webAppGetCompositionsDetailSocialUploadsQueryOptions(id: WebAppGetCompositionsDetailSocialUploadsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetCompositionsDetailSocialUploadsQueryKey(id)
        return queryOptions<WebAppGetCompositionsDetailSocialUploadsQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailSocialUploads401 | WebAppGetCompositionsDetailSocialUploads403>, WebAppGetCompositionsDetailSocialUploadsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetCompositionsDetailSocialUploads(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List social uploads for a composition
 * {@link /web-app/v1/compositions/:id/social-uploads}
 */
export function useWebAppGetCompositionsDetailSocialUploads<TData = WebAppGetCompositionsDetailSocialUploadsQueryResponse, TQueryData = WebAppGetCompositionsDetailSocialUploadsQueryResponse, TQueryKey extends QueryKey = WebAppGetCompositionsDetailSocialUploadsQueryKey>(id: WebAppGetCompositionsDetailSocialUploadsPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetCompositionsDetailSocialUploadsQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailSocialUploads401 | WebAppGetCompositionsDetailSocialUploads403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetCompositionsDetailSocialUploadsQueryKey(id)
         

         const query = useQuery({
          ...webAppGetCompositionsDetailSocialUploadsQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetCompositionsDetailSocialUploads401 | WebAppGetCompositionsDetailSocialUploads403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}